import React, { memo, useMemo } from 'react';
import { formatNumberToKM } from '../../../../../../../sequence/helpers/helper';

/**
 * ProspectDetailsTabTitle component is used to display the tab title and count
 * @param tab - The tab name
 * @param count - The count of the tab
 * @returns
 */
const ProspectDetailsTabTitle: React.FC<{
  tab: string;
  count?: number | string | undefined;
}> = ({ tab, count }) => {
  const isCountValid = useMemo(
    () => count !== '' && count !== undefined && count !== null,
    [count],
  );

  return (
    <div className="d-flex align-items-center">
      <span>{`${tab}`}</span>
      {isCountValid && (
        <span
          className="ml-1 regular-1 font-medium gray-txt-15 gray-16"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '1.25rem',
            lineHeight: '1rem',
            minWidth: '16px',
            height: '16px',
            padding: '4px',
          }}
        >
          {formatNumberToKM(Number(count))}
        </span>
      )}
    </div>
  );
};

export default memo(ProspectDetailsTabTitle);
